// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1N1f_","subheader":"ReorderModal_subheader__2SRAu","listWrap":"ReorderModal_listWrap__1dphF"};